import { TagDelivery, TagPickUp } from 'components/atoms/tags/tags';

export const DELIVERY_TAGS = {
    1: TagDelivery,
    2: TagPickUp,
};
